/**
 * Zuschauer-Intervalle (Contract §13.2).
 *
 * Intervalle à 200 von 1 bis 54.000 → `interval_index = ceil(wert/200)` (max 270).
 * Intervall i deckt `[(i-1)*200+1 .. i*200]` (z. B. i=47 → 9.201–9.400).
 */

export const ATTENDANCE_INTERVAL_SIZE = 200;
export const ATTENDANCE_INTERVAL_COUNT = 270;

const numberFmt = new Intl.NumberFormat('de-DE');

/** Untere/obere Grenze eines Intervalls (1-basiert). */
export function intervalBounds(index: number): { from: number; to: number } {
  const from = (index - 1) * ATTENDANCE_INTERVAL_SIZE + 1;
  const to = index * ATTENDANCE_INTERVAL_SIZE;
  return { from, to };
}

/** Lesbares Label, z. B. „9.201–9.400". */
export function intervalLabel(index: number): string {
  const { from, to } = intervalBounds(index);
  return `${numberFmt.format(from)}–${numberFmt.format(to)}`;
}

/**
 * Kurzform für die Tippübersicht-Tabelle, z. B. „11.3" für 11.201–11.400,
 * „11.5" für 11.401–11.600 usw. (Intervall-Mitte, letzte zwei Stellen weggelassen).
 */
export function shortIntervalLabel(index: number): string {
  const { to } = intervalBounds(index);
  return ((to - 100) / 1000).toFixed(1);
}

/** Tatsächliche Zuschauerzahl → Intervall-Index (für Anzeige der Ist-Werte). */
export function attendanceToInterval(value: number): number {
  if (value <= 0) return 1;
  return Math.min(ATTENDANCE_INTERVAL_COUNT, Math.ceil(value / ATTENDANCE_INTERVAL_SIZE));
}

/** Liste aller wählbaren Intervalle (1..270) mit Label — für Dropdowns. */
export function attendanceIntervals(): { index: number; label: string }[] {
  const out: { index: number; label: string }[] = [];
  for (let i = 1; i <= ATTENDANCE_INTERVAL_COUNT; i += 1) {
    out.push({ index: i, label: intervalLabel(i) });
  }
  return out;
}
